import PropTypes from 'prop-types';

const CheckedIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill={fill} fillRule="nonzero">
          <path
            d="M24,0 C10.7621053,0 0,10.7621053 0,24 C0,37.2378947 10.7621053,48 24,48 C37.2378947,48 48,37.2378947 48,24 C48,10.7621053 37.2378947,0 24,0 Z M34.4084211,19.7557895 L23.4947368,32.7410526 C23.04,33.2968421 22.3831579,33.6 21.6757895,33.6 C20.9684211,33.6 20.3115789,33.2968421 19.8568421,32.7410526 L13.5915789,25.2631579 C12.7326316,24.2526316 12.8842105,22.7873684 13.8947368,21.9284211 C14.9052632,21.0694737 16.3705263,21.2210526 17.2294737,22.2315789 L21.6757895,27.5368421 L30.7705263,16.7242105 C31.6294737,15.7136842 33.0947368,15.6126316 34.1052632,16.4210526 C35.1157895,17.28 35.2673684,18.7452632 34.4084211,19.7557895 Z"
            id="Shape"
          />
        </g>
      </g>
    </svg>
  </div>
);

CheckedIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

CheckedIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default CheckedIcon;
